import { Component, OnInit, Input } from '@angular/core';
import { AppConfig } from '../../../app.config';
import { HelpersService } from '../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-menu-card',
  templateUrl: './menu-card.component.html',
  styleUrls: ['./menu-card.component.scss']
})
export class MenuCardComponent implements OnInit {
  @Input() navigationItems:any;

  // public navigationItems : any = [
  //   {
  //     title: this.translate.instant('bikeshop.community.bikeshop_posts'),
  //     backgroundImage: require('./assets/communication.png'),
  //     description: this.translate.instant('bikeshop.community.bikeshop_posts_description'),
  //     path: 'store/general-communication'
  //   },
  //   {
  //     title: "Bike Shop Rides",
  //     backgroundImage: require('./assets/ride-3.jpg'),
  //     description: "Let's ramp up those coffee rides by sending out push notifications to the customers and providing them with the weather, elevation and distance of the ride.",
  //     path: 'store/community'
  //   },
  //   {
  //     title: "Bike Shop Forum",
  //     backgroundImage: require('./assets/forum.jpg'),
  //     description: "Make your bike shop the heart of your local community - give them the ability to organise group rides, chat about new products, safety concerns and anything that is important to them.",
  //     path: 'store/community'
  //   }
  // ]

  constructor(
    public appConfig: AppConfig,
    public helpersService: HelpersService,
    private translate : TranslateService
  ) { }

  ngOnInit() {
    var partner = this.helpersService.getPartnerData();
  }

}
